import { staticPageConstants } from '../../../../../common/constants/staticPageConstants';

import renderButtonTabsBlock       from './renderButtonTabsBlock';
import renderCardBlock             from './renderCardBlock';
import renderCitiesBlock           from './renderCitiesBlock';
import renderCollapsedBlock        from './renderCollapsedBlock';
import renderCounterBlock          from './renderCounterBlock';
import renderDelimiterBlock        from './renderDelimiterBlock';
import renderDoorSliderBlock       from './renderDoorSliderBlock';
import renderDownloadableCardBlock from './renderDownloadableCardBlock';
import renderGridBlock             from './renderGridBlock';
import renderHighlightedBlock      from './renderHighlightedBlock';
import renderImageBlock            from './renderImageBlock';
import renderImageGalleryBlock     from './renderImageGalleryBlock';
import renderSTBBlock              from './renderSTBBlock';
import renderTabsBlock             from './renderTabsBlock';
import renderTabsWithRouterBlock   from './renderTabsWithRouterBlock';
import renderTextBlock             from './renderTextBlock';
import renderTextWithImageBlock    from './renderTextWithImageBlock';
import renderTradeStoresBlock      from './renderTradeStoresBlock';
import renderTilesBlock            from './renderTilesBlock';
import renderYoutubeVideoBlock     from './renderYoutubeVideoBlock';

export function renderStaticSection(section, index, options = {}) {
  const {
          COMPONENT,
          DATA,
        } = section;

  switch (COMPONENT) {
    case staticPageConstants.COMPONENTS.DELIMITER_BLOCK.LABEL:
      return renderDelimiterBlock(DATA, index);

    case staticPageConstants.COMPONENTS.DOWNLOADABLE_CARD_BLOCK.LABEL:
      return renderDownloadableCardBlock(DATA, index);

    case staticPageConstants.COMPONENTS.BUTTON_TABS.LABEL:
      return renderButtonTabsBlock(DATA, index, renderStaticSection);

    case staticPageConstants.COMPONENTS.CARD.LABEL:
      return renderCardBlock(DATA, index);

    case staticPageConstants.COMPONENTS.CITIES_BLOCK.LABEL:
      return renderCitiesBlock(DATA, index);

    case staticPageConstants.COMPONENTS.COLLAPSED_BLOCK.LABEL:
      return renderCollapsedBlock(DATA, index, options);

    case staticPageConstants.COMPONENTS.COUNTER_BLOCK.LABEL:
      return renderCounterBlock(DATA, index);

    case staticPageConstants.COMPONENTS.GRID.LABEL:
      return renderGridBlock(DATA, index, renderStaticSection);

    case staticPageConstants.COMPONENTS.DOOR_SLIDER.LABEL:
      return renderDoorSliderBlock(DATA, index);

    case staticPageConstants.COMPONENTS.HIGHLIGHTED_BLOCK.LABEL:
      return renderHighlightedBlock(DATA, index);

    case staticPageConstants.COMPONENTS.IMAGE.LABEL:
      return renderImageBlock(DATA, index);

    case staticPageConstants.COMPONENTS.IMAGE_GALLERY.LABEL:
      return renderImageGalleryBlock(DATA, index);

    case staticPageConstants.COMPONENTS.STB.LABEL:
      return renderSTBBlock(DATA, index);

    case staticPageConstants.COMPONENTS.TABS.LABEL:
      return renderTabsBlock(DATA, index, renderStaticSection);

    case staticPageConstants.COMPONENTS.TABS_WITH_ROUTER.LABEL:
      return renderTabsWithRouterBlock(DATA, index, renderStaticSection);

    case staticPageConstants.COMPONENTS.TEXT_BLOCK.LABEL:
      return renderTextBlock(DATA, index);

    case staticPageConstants.COMPONENTS.TEXT_WITH_IMAGE.LABEL:
      return renderTextWithImageBlock(DATA, index);

    case staticPageConstants.COMPONENTS.TILES.LABEL:
      return renderTilesBlock(DATA, index);

    case staticPageConstants.OPTIONAL_COMPONENTS.TRADE_STORES.LABEL:
      return renderTradeStoresBlock(DATA, index);

    case staticPageConstants.COMPONENTS.YOUTUBE_VIDEO.LABEL:
      return renderYoutubeVideoBlock(DATA, index);

    default:
      return null;
  }
}

export default renderStaticSection;